<template>
<div>
    <h2 class="bg-secondary p-2 rounded text-white">Formulaire clientelle</h2>
    <ClientForm @save="goToClient" @edit="goToClient" :item="client"/>

</div>
</template>

<script>

import ClientForm from '@/components/forms/ClientForm.vue';
export default {
    name: 'ClientCreate',
    components: { ClientForm },
    props: {
        id: {
            type: [String, Number],
            default: null,
        }
    },
    data() {
        return {
            client: null,
        }
    },

    methods: {
        goToClient(client) {
            this.$router.push({ name: 'clients.view', params: { id: client.id } });
        },
        getClient() {
            if (this.id) {
                this.$api.get(`/clients/${this.id}`)
                    .then(response => {
                        this.client = response.data.data;
                    })
                    .catch(error => {
                        console.error('There was an error fetching the client!', error);
                    });
            }
        }   
    },
    created() {
        this.getClient();
    }
}
</script>